import { DECREASE_STOCK_PRODUCT, GET_PRODUCT_CARD_FAILURE, GET_PRODUCT_CARD_REQUEST, GET_PRODUCT_CARD_SUCCESS, SET_PRODUCT_CARD_INITIAL_STATE, } from './actionTypes';
const initialState = {
    data: undefined,
    isLoaded: false,
    isLoading: false,
    error: null,
};
export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_PRODUCT_CARD_REQUEST: {
            return {
                ...initialState,
                isLoading: true,
            };
        }
        case GET_PRODUCT_CARD_SUCCESS: {
            return {
                ...state,
                data: action.payload?.data,
                isLoaded: true,
                isLoading: false,
            };
        }
        case GET_PRODUCT_CARD_FAILURE: {
            return {
                ...state,
                data: action.payload?.data,
                isLoading: false,
            };
        }
        case DECREASE_STOCK_PRODUCT: {
            const { sku, quantity, resetStock } = action.payload;
            return {
                ...state,
                data: state.data
                    ? {
                        ...state.data,
                        variants: state.data.variants.map((variant) => {
                            if (variant.sku === sku) {
                                return {
                                    ...variant,
                                    stock: resetStock ? 0 : variant.stock - quantity,
                                };
                            }
                            return variant;
                        }),
                    }
                    : undefined,
            };
        }
        case SET_PRODUCT_CARD_INITIAL_STATE: {
            return initialState;
        }
        default:
            return state;
    }
};
